import { render, staticRenderFns } from "./PlugPage.vue?vue&type=template&id=71fef82d"
import script from "./PlugPage.vue?vue&type=script&lang=js"
export * from "./PlugPage.vue?vue&type=script&lang=js"
import style0 from "./PlugPage.vue?vue&type=style&index=0&id=71fef82d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports